import ManualCarousel, {
  CarouselItem,
} from "../components/service-carousel/ServiceCarousel";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { Button, CardActions, Typography } from "@mui/material";

const Services = ({ isMobile, services }) => {
  const servicesList = [];
  let chunkSize;
  if (isMobile) {
    chunkSize = 1;
  } else {
    chunkSize = 3;
  }

  for (let i = 0; i < services.length; i += chunkSize) {
    const chunk = services.slice(i, i + chunkSize);
    servicesList.push(chunk);
  }

  return (
    <div className="mt-8 bg-transparent px-7 lg:px-0 lg:w-5/6 xl:w-4/5 mx-auto">
      <h2 className="text-4xl xl:text-5xl tracking-wide mb-24 xl:mb-32">
        Company Services
      </h2>
      <div className="grid grid-cols-3 lg:grid-cols-4">
        <div className="hidden lg:block lg:w-5/6 xl:w-3/4">
          <h3 className="font-semibold xl:font-normal text-2xl xl:text-3xl tracking-wide">
            Explore Our Services
          </h3>
          <p className="text-sm xl:text-base">
            Get a glimpse of how we work to improve lives
          </p>
          <div className="h-0.5 w-full bg-black mt-8"></div>
        </div>

        <ManualCarousel className="col-span-3 h-96 overflow-x-clip">
          {servicesList.map((service, i) => (
            <CarouselItem key={i}>
              {service.map((s) => (
                <Card
                  sx={{ maxWidth: 350 }}
                  key={s._id}
                  className="transform transition-all duration-100 ease-linear hover:border-2 border-blue-600 border-opacity-60 hover:shadow-xl"
                >
                  <CardMedia
                    className="p-3 max-h-60 transform transition-all duration-100 ease-linear hover:p-0"
                    component="img"
                    height="150"
                    image={s.image}
                    alt="Article"
                  />
                  <CardContent>
                    <Typography
                      style={{ fontSize: "1.5rem" }}
                      gutterBottom
                      variant="h5"
                      component="div"
                    >
                      {s.name}
                    </Typography>
                    <Typography
                      gutterBottom
                      variant="caption"
                      component="div"
                      style={{ padding: 0, margin: 0 }}
                    >
                      {s.description.slice(0, 50)}
                    </Typography>
                  </CardContent>
                  <CardActions className="flex justify-end">
                    <Button
                      style={{
                        backgroundColor: "#001A6C",
                        fontSize: "10px",
                        textTransform: "capitalize",
                        borderRadius: "0",
                      }}
                      variant="contained"
                      size="small"
                      color="primary"
                    >
                      Read More
                    </Button>
                  </CardActions>
                </Card>
              ))}
            </CarouselItem>
          ))}
        </ManualCarousel>
      </div>
    </div>
  );
};

export default Services;
